import Drawer from "@material-ui/core/Drawer";
import React from "react";
import DeviceSettings from "./DeviceSettings";

export default function DeviceSettingsDrawer({deviceId, open, width, onClose}) {
    if (!open) {
        return null;
    }

    return (
        <Drawer open={open}
                anchor={"right"}
                variant={"temporary"}
                BackdropProps={{invisible: true}}
                onBackdropClick={onClose}
        >
            <DeviceSettings deviceId={deviceId}
                            width={width}
                            onClose={onClose}
            />
        </Drawer>
    );
}